import React from 'react'
import injectStyles from 'react-jss'
import moment from 'moment'

import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'

import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'

import styles from './styles.js'

import classNames from 'classnames'
import { CREDENTIALS_HEADERS } from './options.js'
import CopyButton from '../CopyButton'
import { KEY_STATUS } from '../../const.js'
import ActionButton from '../ActionButton'
import usePosthogAnalyticsIntegrations from '../../../hooks/usePosthogAnalyiticsIntegrations.js'

const CredentialsTable = ({
  data,
  addRowData,
  onCreate,
  onRevoke,
  classes,
}) => {
  const renderTableCell = ({ row, key, type }) => {
    const { emitAnalyticsEvent } = usePosthogAnalyticsIntegrations()

    switch (type) {
      case 'name':
        return row && row[key] ? (
          <Typography
            className={classNames({
              [classes.text]: true,
              [classes.comment]: true,
            })}
          >
            {row[key] || '-'}
          </Typography>
        ) : (
          <Typography
            className={classNames({
              [classes.text]: true,
              [classes.comment]: true,
            })}
          >
            {'-'}
          </Typography>
        )

      case 'token':
        return row && row[key] ? (
          <div className={classes.tokenContainer}>
            <Typography
              className={classNames({
                [classes.text]: true,
                [classes.token]: true,
              })}
            >
              {row[key]}
            </Typography>
            <CopyButton
              onClick={() => {
                navigator.clipboard.writeText(row[key])
                emitAnalyticsEvent('Token Action', {
                  type: 'web_api',
                  action_type: 'copy',
                })
              }}
              cypressId="copyBtn"
            />
          </div>
        ) : (
          <div className={classes.tokenContainer}>
            <Typography
              className={classNames({
                [classes.text]: true,
                [classes.token]: true,
              })}
            >
              &nbsp;
            </Typography>
            {data && data.length > 0 && (
              <div style={{ opacity: 0, pointerEvents: 'none' }}>
                <CopyButton
                  onClick={() => {
                    navigator.clipboard.writeText(row[key])
                  }}
                  cypressId="copyBtn"
                />
              </div>
            )}
          </div>
        )

      case 'date':
        return (
          <Typography
            className={classNames({
              [classes.text]: true,
              [classes.comment]: true,
            })}
          >
            {row && row[key] ? moment(row[key]).format('YYYY-MM-DD') : '-'}
          </Typography>
        )

      case 'actions':
        return (
          <ActionButton
            row={row}
            onRevoke={onRevoke}
            onCreate={onCreate}
            cypressId="actionBtn"
          />
        )

      case 'status':
        return (
          <div
            className={classNames({
              [classes.label]: true,
              [classes.labelActive]: row.status === KEY_STATUS.ACTIVE,
              [classes.labelInactive]: row.status !== KEY_STATUS.ACTIVE,
              [classes.labelHidden]:
                row.status === null || row.status === undefined,
            })}
          >
            {row && row.status === KEY_STATUS.ACTIVE ? 'Active' : 'Inactive'}
          </div>
        )

      default:
        return <Typography>{row[key]}</Typography>
    }
  }

  return (
    <Box className={classes.wrapper}>
      <Box className={classes.table}>
        <TableContainer className={classes.tableContainer}>
          <Table stickyHeader size="medium" cypress_id="integrationKeysTable">
            <TableHead className={classes.tableHead}>
              <TableRow className={classes.tableRow}>
                {CREDENTIALS_HEADERS.map((headCell, index) => (
                  <TableCell
                    key={headCell.key}
                    align={index === 0 ? 'left' : 'center'}
                    className={
                      index !== 0
                        ? classes.tableHeaderCell
                        : classes.firstTableHeaderCell
                    }
                  >
                    <Typography className={classes.tableHeadersLabel}>
                      {headCell.label}
                    </Typography>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data &&
                data.map(row => {
                  return (
                    <TableRow
                      hover={false}
                      tabIndex={-1}
                      key={row.id}
                      className={classes.tableRow}
                    >
                      {CREDENTIALS_HEADERS.map(({ key, type }, index) => {
                        return index === CREDENTIALS_HEADERS.length - 1 ? (
                          <TableCell align={'center'}>
                            {renderTableCell({ row, key, type })}
                          </TableCell>
                        ) : (
                          <TableCell align={'left'}>
                            {renderTableCell({ row, key, type })}
                          </TableCell>
                        )
                      })}
                    </TableRow>
                  )
                })}
              {addRowData ? (
                <TableRow
                  hover={false}
                  tabIndex={-1}
                  key={addRowData.id}
                  className={classes.tableRow}
                >
                  {CREDENTIALS_HEADERS.map(({ key, type }, index) => {
                    return index === CREDENTIALS_HEADERS.length - 1 ? (
                      <TableCell align={'center'}>
                        {renderTableCell({ row: addRowData, key, type })}
                      </TableCell>
                    ) : (
                      <TableCell align={'left'}>
                        {renderTableCell({ row: addRowData, key, type })}
                      </TableCell>
                    )
                  })}
                </TableRow>
              ) : null}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  )
}

export default injectStyles(styles)(CredentialsTable)
